import React, { Fragment, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../Escritorio/Instrucciones';

import useConfigAuth from '../../../../Hooks/useConfigAuth';

import BotoneraBottom from '../../Compartidos/BotoneraBottom';

import {
    finalizarEjercicioAction,
    setearEjercicioAction,
    setearUrlAnteriorAction
} from '../../../../actions/estadoEjercicioActions';

import { almacenarAction } from '../../../../actions/almacenarEjercicioActions';

import { ContainerFlex } from '../../../Css/MetodosCSS/StyledLN2Todos';

import {
    AvanzarImg,
    AvanzarBtn,
    PantallaM154,
    ContenidoM154,
    NumeroObjetivoM154,
    ZonaTrabajoM154,
    ActividadM154,
    EscenaM154,
    BottomM154
} from '../../../Css/StyledMatematica';


// ============================================================================
// CONFIGURACIÓN
// ============================================================================

const CANTIDAD_EJERCICIOS = 3;

const MAX_PARTES = 12;
const MAX_ENTEROS = 5;

const ACCENT = '#23AAAF';
const MARK = '#E8662B';
const OK = '#2E8B57';
const INK = '#222222';
const PINTADO = '#F2A541';

const miniInstrucciones =
    'Representá el número de tres maneras: con objetos, con bandejas y en la recta numérica.';


// ============================================================================
// BANCO DE NÚMEROS
// ============================================================================

const NUMEROS = [

    {
        e: 0,
        num: 1,
        den: 2
    },

    {
        e: 0,
        num: 3,
        den: 4
    },

    {
        e: 1,
        num: 1,
        den: 2
    },

    {
        e: 2,
        num: 1,
        den: 4
    },

    {
        e: 0,
        num: 2,
        den: 3
    },

    {
        e: 1,
        num: 2,
        den: 3
    },

    {
        e: 0,
        num: 5,
        den: 4
    },

    {
        e: 0,
        num: 3,
        den: 8
    },

    {
        e: 2,
        num: 3,
        den: 4
    },

    {
        e: 0,
        num: 5,
        den: 6
    },

    {
        e: 3,
        num: 1,
        den: 2
    },

    {
        e: 0,
        num: 7,
        den: 4
    },

    {
        e: 1,
        num: 1,
        den: 3
    },

    {
        e: 0,
        num: 4,
        den: 5
    },

    {
        e: 1,
        num: 5,
        den: 8
    },

    {
        e: 0,
        num: 3,
        den: 2
    },

    {
        e: 2,
        num: 1,
        den: 3
    },

    {
        e: 0,
        num: 1,
        den: 6
    },

    {
        e: 1,
        num: 3,
        den: 4
    },

    {
        e: 0,
        num: 9,
        den: 4
    }

];


// ============================================================================
// COLORES DE LAS BEBIDAS
// ============================================================================

const BEBIDAS = {

    jugo: {
        color: '#F59E0B',
        tapa: '#2E8B57'
    },

    gaseosa: {
        color: '#F28C28',
        tapa: '#C62828'
    },

    agua: {
        color: '#7EC8E3',
        tapa: '#1E88E5'
    }

};


// ============================================================================
// AUXILIARES
// ============================================================================

const range = (
    cantidad
) => {

    return Array.from(
        {
            length: cantidad
        },
        (_, index) => index
    );
};


const cursor = (
    activo
) => ({
    cursor:
        activo
            ? 'pointer'
            : 'default'
});


const mezclar = (
    array
) => {

    const copia = [
        ...array
    ];


    for (
        let i = copia.length - 1;
        i > 0;
        i--
    ) {

        const j =
            Math.floor(
                Math.random() *
                (
                    i + 1
                )
            );


        [
            copia[i],
            copia[j]
        ] = [
            copia[j],
            copia[i]
        ];
    }


    return copia;
};


const textoNumero = (
    numero
) => {

    if (
        numero.e > 0
    ) {

        return (
            `${numero.e} y ${numero.num}/${numero.den}`
        );
    }


    return (
        `${numero.num}/${numero.den}`
    );
};


// ============================================================================
// FUNCIONES DE DIBUJO
// ============================================================================

const sector = (
    cx,
    cy,
    r,
    a0,
    a1
) => {

    if (
        a1 - a0 >= 359.99
    ) {

        return (
            `M${cx - r} ${cy}
             A${r} ${r} 0 1 1 ${cx + r} ${cy}
             A${r} ${r} 0 1 1 ${cx - r} ${cy} Z`
        );
    }


    const punto = (
        angulo
    ) => [

        cx +
        r *
        Math.sin(
            (
                angulo *
                Math.PI
            ) /
            180
        ),

        cy -
        r *
        Math.cos(
            (
                angulo *
                Math.PI
            ) /
            180
        )
    ];


    const [
        x0,
        y0
    ] = punto(
        a0
    );


    const [
        x1,
        y1
    ] = punto(
        a1
    );


    const large =
        a1 - a0 > 180
            ? 1
            : 0;


    return (
        `M${cx} ${cy}
         L${x0} ${y0}
         A${r} ${r} 0 ${large} 1 ${x1} ${y1}
         Z`
    );
};


const cortes = (
    cx,
    cy,
    r,
    n,
    offset,
    props
) => {

    if (
        n < 2
    ) {

        return null;
    }


    return range(
        n
    )
        .map(
            index => {

                const angulo =
                    (
                        offset +
                        (
                            index *
                            360
                        ) /
                        n
                    ) *
                    Math.PI /
                    180;


                return (

                    <line
                        key={
                            index
                        }
                        x1={
                            cx
                        }
                        y1={
                            cy
                        }
                        x2={
                            cx +
                            r *
                            Math.sin(
                                angulo
                            )
                        }
                        y2={
                            cy -
                            r *
                            Math.cos(
                                angulo
                            )
                        }
                        {...props}
                    />
                );
            }
        );
};


// ============================================================================
// PIZZA
// ============================================================================

const INGREDIENTES = [

    [15, 80, 'a'],
    [100, 78, 'a'],
    [165, 82, 'a'],
    [205, 76, 'a'],
    [255, 80, 'a'],
    [320, 78, 'a'],

    [52, 44, 't'],
    [140, 42, 't'],
    [232, 44, 't'],
    [280, 40, 't'],
    [345, 46, 't'],
    [0, 0, 'a']

];


const PizzaUna = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const cx = 150;
    const cy = 150;

    const paso =
        360 /
        n;


    return (

        <svg
            viewBox="0 0 300 300"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Pizza"
        >

            <circle
                cx={
                    cx
                }
                cy={
                    cy
                }
                r={
                    142
                }
                fill="#FFFFFF"
                stroke="#CFCFCF"
                strokeWidth={
                    3
                }
            />


            {
                range(
                    n
                )
                    .map(
                        index => {

                            const a0 =
                                index *
                                paso;

                            const a1 =
                                (
                                    index +
                                    1
                                ) *
                                paso;


                            if (
                                q[
                                    index
                                ]
                            ) {

                                return (

                                    <path
                                        key={
                                            index
                                        }
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                126,
                                                a0 + 0.8,
                                                a1 - 0.8
                                            )
                                        }
                                        fill="#FFFFFF"
                                        stroke="#9E9E9E"
                                        strokeWidth={
                                            2.5
                                        }
                                        strokeDasharray="7 6"
                                        strokeLinejoin="round"
                                        onClick={() =>
                                            onTocar(
                                                index
                                            )
                                        }
                                        style={
                                            cursor(
                                                activo
                                            )
                                        }
                                    />
                                );
                            }


                            const propios =
                                INGREDIENTES
                                    .filter(
                                        (
                                            [
                                                angulo
                                            ]
                                        ) =>

                                            Math.floor(
                                                angulo /
                                                paso
                                            ) %
                                            n ===
                                            index
                                    );


                            return (

                                <g
                                    key={
                                        index
                                    }
                                    onClick={() =>
                                        onTocar(
                                            index
                                        )
                                    }
                                    style={
                                        cursor(
                                            activo
                                        )
                                    }
                                >

                                    <path
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                128,
                                                a0,
                                                a1
                                            )
                                        }
                                        fill="#D99A4E"
                                    />


                                    <path
                                        d={
                                            sector(
                                                cx,
                                                cy,
                                                112,
                                                a0,
                                                a1
                                            )
                                        }
                                        fill="#F7D774"
                                    />


                                    {
                                        propios.map(
                                            (
                                                [
                                                    angulo,
                                                    radio,
                                                    tipo
                                                ],
                                                k
                                            ) => {

                                                const x =
                                                    cx +
                                                    radio *
                                                    Math.sin(
                                                        (
                                                            angulo *
                                                            Math.PI
                                                        ) /
                                                        180
                                                    );

                                                const y =
                                                    cy -
                                                    radio *
                                                    Math.cos(
                                                        (
                                                            angulo *
                                                            Math.PI
                                                        ) /
                                                        180
                                                    );


                                                if (
                                                    tipo === 'a'
                                                ) {

                                                    return (

                                                        <g
                                                            key={
                                                                k
                                                            }
                                                        >

                                                            <circle
                                                                cx={
                                                                    x
                                                                }
                                                                cy={
                                                                    y
                                                                }
                                                                r={
                                                                    7
                                                                }
                                                                fill="#2E3B1F"
                                                            />

                                                            <circle
                                                                cx={
                                                                    x
                                                                }
                                                                cy={
                                                                    y
                                                                }
                                                                r={
                                                                    2.5
                                                                }
                                                                fill="#7A8A55"
                                                            />

                                                        </g>
                                                    );
                                                }


                                                return (

                                                    <circle
                                                        key={
                                                            k
                                                        }
                                                        cx={
                                                            x
                                                        }
                                                        cy={
                                                            y
                                                        }
                                                        r={
                                                            6
                                                        }
                                                        fill="#D9442B"
                                                        opacity={
                                                            0.85
                                                        }
                                                    />
                                                );
                                            }
                                        )
                                    }

                                </g>
                            );
                        }
                    )
            }


            <g
                pointerEvents="none"
            >

                {
                    cortes(
                        cx,
                        cy,
                        130,
                        n,
                        0,
                        {
                            stroke:
                                '#FFFFFF',

                            strokeWidth:
                                5
                        }
                    )
                }

            </g>

        </svg>
    );
};


// ============================================================================
// HELADO
// ============================================================================

const HeladoUno = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const sabores = [
        '#C68B4E',
        '#6B3E26',
        '#F4A3B4',
        '#F2EBB5',
        '#C5E1A5',
        '#FFCC80'
    ];


    const r = 110;
    const ry = 44;

    const escala =
        ry /
        r;

    const cx = 160;
    const topY = 70;

    const paso =
        360 /
        n;

    const offset =
        n === 4
            ? 45
            : 0;


    return (

        <svg
            viewBox="0 0 320 260"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Pote de un kilo de helado"
        >

            <g
                pointerEvents="none"
            >

                <path
                    d={
                        `M${cx - 128} ${topY}
                         L${cx - 98} ${topY + 160}
                         Q${cx} ${topY + 186} ${cx + 98} ${topY + 160}
                         L${cx + 128} ${topY}
                         Z`
                    }
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                    strokeWidth={
                        3
                    }
                    strokeLinejoin="round"
                />


                <text
                    x={
                        cx
                    }
                    y={
                        topY +
                        120
                    }
                    textAnchor="middle"
                    fontSize="22"
                    fontWeight="800"
                    fill="#9E9E9E"
                    letterSpacing="2"
                >
                    1 KG
                </text>


                <ellipse
                    cx={
                        cx
                    }
                    cy={
                        topY
                    }
                    rx={
                        128
                    }
                    ry={
                        50
                    }
                    fill="#FFFFFF"
                    stroke="#BDBDBD"
                    strokeWidth={
                        3
                    }
                />


                <ellipse
                    cx={
                        cx
                    }
                    cy={
                        topY
                    }
                    rx={
                        r +
                        2
                    }
                    ry={
                        ry +
                        1
                    }
                    fill="#E9E9E9"
                />

            </g>


            <g
                transform={
                    `translate(${cx} ${topY}) scale(1 ${escala})`
                }
            >

                {
                    range(
                        n
                    )
                        .map(
                            index => {

                                const a0 =
                                    offset +
                                    index *
                                    paso;

                                const a1 =
                                    offset +
                                    (
                                        index +
                                        1
                                    ) *
                                    paso;

                                const vacio =
                                    q[
                                        index
                                    ];


                                return (

                                    <g
                                        key={
                                            index
                                        }
                                        onClick={() =>
                                            onTocar(
                                                index
                                            )
                                        }
                                        style={
                                            cursor(
                                                activo
                                            )
                                        }
                                    >

                                        <path
                                            d={
                                                sector(
                                                    0,
                                                    0,
                                                    r,
                                                    a0,
                                                    a1
                                                )
                                            }
                                            fill={
                                                vacio

                                                    ? '#ECECEC'

                                                    : sabores[
                                                        index %
                                                        sabores.length
                                                    ]
                                            }
                                        />

                                    </g>
                                );
                            }
                        )
                }


                <g
                    pointerEvents="none"
                >

                    {
                        cortes(
                            0,
                            0,
                            r,
                            n,
                            offset,
                            {
                                stroke:
                                    '#FFFFFF',

                                strokeWidth:
                                    4,

                                vectorEffect:
                                    'non-scaling-stroke'
                            }
                        )
                    }

                </g>

            </g>

        </svg>
    );
};


// ============================================================================
// CHOCOLATE
// ============================================================================

const ChocolateUna = ({
    n,
    q,
    onTocar,
    activo,
    size
}) => {

    const x0 = 8;
    const y0 = 8;

    const W = 360;
    const H = 120;

    const cols = 12;
    const rows = 3;

    const cw =
        W /
        cols;

    const ch =
        H /
        rows;

    const pw =
        W /
        n;


    return (

        <svg
            viewBox="0 0 376 136"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Chocolate"
        >

            <g
                pointerEvents="none"
            >

                <rect
                    x={
                        x0 -
                        4
                    }
                    y={
                        y0 -
                        4
                    }
                    width={
                        W +
                        8
                    }
                    height={
                        H +
                        8
                    }
                    rx={
                        8
                    }
                    fill="#7B4A2A"
                />


                {
                    range(
                        cols
                    )
                        .map(
                            columna =>

                                range(
                                    rows
                                )
                                    .map(
                                        fila => {

                                            const x =
                                                x0 +
                                                columna *
                                                cw +
                                                3;

                                            const y =
                                                y0 +
                                                fila *
                                                ch +
                                                3;

                                            const width =
                                                cw -
                                                6;

                                            const height =
                                                ch -
                                                6;


                                            return (

                                                <g
                                                    key={
                                                        `${columna}-${fila}`
                                                    }
                                                >

                                                    <rect
                                                        x={
                                                            x
                                                        }
                                                        y={
                                                            y
                                                        }
                                                        width={
                                                            width
                                                        }
                                                        height={
                                                            height
                                                        }
                                                        rx={
                                                            3
                                                        }
                                                        fill="#94592F"
                                                    />


                                                    <path
                                                        d={
                                                            `M${x + 2} ${y + height - 2}
                                                             L${x + 2} ${y + 2}
                                                             L${x + width - 2} ${y + 2}`
                                                        }
                                                        fill="none"
                                                        stroke="#B07446"
                                                        strokeWidth={
                                                            2.5
                                                        }
                                                        strokeLinecap="round"
                                                    />

                                                </g>
                                            );
                                        }
                                    )
                        )
                }


                {
                    range(
                        n
                    )
                        .map(
                            index =>

                                q[
                                    index
                                ] && (

                                    <g
                                        key={
                                            index
                                        }
                                    >

                                        <rect
                                            x={
                                                x0 +
                                                index *
                                                pw -
                                                4
                                            }
                                            y={
                                                0
                                            }
                                            width={
                                                pw +
                                                8
                                            }
                                            height={
                                                136
                                            }
                                            fill="#FFFFFF"
                                        />


                                        <rect
                                            x={
                                                x0 +
                                                index *
                                                pw +
                                                3
                                            }
                                            y={
                                                y0
                                            }
                                            width={
                                                pw -
                                                6
                                            }
                                            height={
                                                H
                                            }
                                            rx={
                                                6
                                            }
                                            fill="none"
                                            stroke="#9E9E9E"
                                            strokeWidth={
                                                2.5
                                            }
                                            strokeDasharray="7 6"
                                        />

                                    </g>
                                )
                        )
                }


                {
                    range(
                        n -
                        1
                    )
                        .map(
                            index => (

                                <line
                                    key={
                                        index
                                    }
                                    x1={
                                        x0 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y1={
                                        0
                                    }
                                    x2={
                                        x0 +
                                        (
                                            index +
                                            1
                                        ) *
                                        pw
                                    }
                                    y2={
                                        136
                                    }
                                    stroke="#FFFFFF"
                                    strokeWidth={
                                        6
                                    }
                                />
                            )
                        )
                }

            </g>


            {
                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    x0 +
                                    index *
                                    pw
                                }
                                y={
                                    0
                                }
                                width={
                                    pw
                                }
                                height={
                                    136
                                }
                                fill="transparent"
                                style={
                                    cursor(
                                        activo
                                    )
                                }
                                onClick={() =>
                                    onTocar(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// BOTELLA
// ============================================================================

const BotellaUna = ({
    n,
    q,
    onTocar,
    activo,
    size,
    bebida,
    id
}) => {

    const top = 105;
    const bottom = 290;

    const alto =
        bottom -
        top;

    const bh =
        alto /
        n;

    const nivel =
        n -
        q.filter(
            Boolean
        ).length;


    const {
        color,
        tapa
    } =
        BEBIDAS[
            bebida
        ] ||
        BEBIDAS.jugo;


    const contorno =
        'M62 22 h36 v33 q32 10 32 50 v165 q0 20 -20 20 h-60 q-20 0 -20 -20 v-165 q0 -40 32 -50 z';


    const clip =
        `clip-${id}`;


    return (

        <svg
            viewBox="0 0 160 300"
            style={{
                width:
                    size,

                height:
                    'auto',

                display:
                    'block'
            }}
            role="img"
            aria-label="Botella"
        >

            <defs>

                <clipPath
                    id={
                        clip
                    }
                >

                    <path
                        d={
                            contorno
                        }
                    />

                </clipPath>

            </defs>


            <g
                pointerEvents="none"
            >

                <path
                    d={
                        contorno
                    }
                    fill="#F7FBFC"
                />


                <rect
                    x={
                        0
                    }
                    y={
                        bottom -
                        nivel *
                        bh
                    }
                    width={
                        160
                    }
                    height={
                        nivel *
                        bh +
                        10
                    }
                    fill={
                        color
                    }
                    clipPath={
                        `url(#${clip})`
                    }
                />


                {
                    n >
                    1 &&

                    range(
                        n
                    )
                        .map(
                            index => {

                                const y =
                                    bottom -
                                    (
                                        index +
                                        1
                                    ) *
                                    bh;


                                return (

                                    <line
                                        key={
                                            index
                                        }
                                        x1={
                                            30
                                        }
                                        y1={
                                            y
                                        }
                                        x2={
                                            130
                                        }
                                        y2={
                                            y
                                        }
                                        stroke={
                                            INK
                                        }
                                        strokeWidth={
                                            2
                                        }
                                        strokeDasharray="6 5"
                                        opacity={
                                            0.7
                                        }
                                    />
                                );
                            }
                        )
                }


                <path
                    d={
                        contorno
                    }
                    fill="none"
                    stroke={
                        INK
                    }
                    strokeWidth={
                        3
                    }
                />


                <rect
                    x={
                        58
                    }
                    y={
                        6
                    }
                    width={
                        44
                    }
                    height={
                        20
                    }
                    rx={
                        4
                    }
                    fill={
                        tapa
                    }
                    stroke={
                        INK
                    }
                    strokeWidth={
                        2
                    }
                />

            </g>


            {
                range(
                    n
                )
                    .map(
                        index => (

                            <rect
                                key={
                                    index
                                }
                                x={
                                    28
                                }
                                y={
                                    bottom -
                                    (
                                        index +
                                        1
                                    ) *
                                    bh
                                }
                                width={
                                    104
                                }
                                height={
                                    bh
                                }
                                fill="transparent"
                                style={
                                    cursor(
                                        activo
                                    )
                                }
                                onClick={() =>
                                    onTocar(
                                        index
                                    )
                                }
                            />
                        )
                    )
            }

        </svg>
    );
};


// ============================================================================
// NÚMERO OBJETIVO
// ============================================================================

const Numero = ({
    e,
    num,
    den,
    size = 90
}) => {

    const fraccion =
        size *
        0.6;


    return (

        <div
            style={{
                display:
                    'inline-flex',

                alignItems:
                    'center',

                justifyContent:
                    'center',

                gap:
                    size *
                    0.18,

                fontFamily:
                    'Nunito',

                fontWeight:
                    800,

                color:
                    INK,

                lineHeight:
                    1
            }}
        >

            {
                e >
                0 && (

                    <span
                        style={{
                            fontSize:
                                size
                        }}
                    >
                        {
                            e
                        }
                    </span>
                )
            }


            {
                num >
                0 && (

                    <span
                        style={{
                            display:
                                'inline-flex',

                            flexDirection:
                                'column',

                            alignItems:
                                'center'
                        }}
                    >

                        <span
                            style={{
                                fontSize:
                                    fraccion
                            }}
                        >
                            {
                                num
                            }
                        </span>


                        <span
                            style={{
                                width:
                                    fraccion *
                                    1.2,

                                height:
                                    Math.max(
                                        3,
                                        size /
                                        16
                                    ),

                                background:
                                    INK,

                                borderRadius:
                                    2,

                                margin:
                                    `${size * 0.06}px 0`
                            }}
                        />


                        <span
                            style={{
                                fontSize:
                                    fraccion
                            }}
                        >
                            {
                                den
                            }
                        </span>

                    </span>
                )
            }

        </div>
    );
};


// ============================================================================
// BOTONES
// ============================================================================

const boton = {

    fontFamily:
        'Nunito',

    fontSize:
        17,

    fontWeight:
        600,

    padding:
        '8px 16px',

    borderRadius:
        12,

    border:
        `2px solid ${ACCENT}`,

    background:
        '#FFFFFF',

    color:
        ACCENT,

    cursor:
        'pointer'
};


const botonSeleccionado = {

    ...boton,

    background:
        '#E6F4F4'
};


const botonPequeno = {

    ...boton,

    padding:
        '4px 14px',

    fontSize:
        22,

    lineHeight:
        1
};


// ============================================================================
// CONTROL PARTIR
// ============================================================================

const Partir = ({
    valor,
    onCambio,
    disabled,
    texto = 'Partir en:'
}) => {

    return (

        <div
            style={{
                display:
                    'flex',

                alignItems:
                    'center',

                justifyContent:
                    'center',

                gap:
                    12,

                fontFamily:
                    'Nunito',

                fontSize:
                    19,

                fontWeight:
                    700
            }}
        >

            <span>
                {
                    texto
                }
            </span>


            <button
                type="button"
                style={{
                    ...botonPequeno,

                    opacity:
                        disabled ||
                        valor <= 1

                            ? 0.4
                            : 1,

                    cursor:
                        disabled ||
                        valor <= 1

                            ? 'default'
                            : 'pointer'
                }}
                disabled={
                    disabled ||
                    valor <= 1
                }
                onClick={() =>
                    onCambio(
                        valor -
                        1
                    )
                }
            >
                −
            </button>


            <span
                style={{
                    minWidth:
                        30,

                    textAlign:
                        'center',

                    fontSize:
                        26
                }}
            >
                {
                    valor
                }
            </span>


            <button
                type="button"
                style={{
                    ...botonPequeno,

                    opacity:
                        disabled ||
                        valor >= MAX_PARTES

                            ? 0.4
                            : 1,

                    cursor:
                        disabled ||
                        valor >= MAX_PARTES

                            ? 'default'
                            : 'pointer'
                }}
                disabled={
                    disabled ||
                    valor >= MAX_PARTES
                }
                onClick={() =>
                    onCambio(
                        valor +
                        1
                    )
                }
            >
                +
            </button>

        </div>
    );
};


// ============================================================================
// OBJETOS DISPONIBLES
// ============================================================================

const OBJETOS = [

    {
        tipo:
            'pizza',

        nombre:
            'Pizza',

        Uno:
            PizzaUna,

        tam:
            cantidad => {

                if (
                    cantidad === 1
                ) {

                    return 220;
                }


                if (
                    cantidad === 2
                ) {

                    return 175;
                }


                return 135;
            }
    },

    {
        tipo:
            'chocolate',

        nombre:
            'Chocolate',

        Uno:
            ChocolateUna,

        tam:
            cantidad =>

                cantidad === 1
                    ? 340
                    : 210
    },

    {
        tipo:
            'helado',

        nombre:
            'Helado',

        Uno:
            HeladoUno,

        tam:
            cantidad =>

                cantidad === 1
                    ? 230
                    : 170
    },

    {
        tipo:
            'botella',

        nombre:
            'Botella',

        Uno:
            BotellaUna,

        tam:
            cantidad =>

                cantidad <= 2
                    ? 115
                    : 90
    }

];


// ============================================================================
// RENDER DE OBJETOS
// ============================================================================

const Objetos = ({
    tipo,
    cantidad,
    n,
    q,
    onTocar,
    activo
}) => {

    if (
        !tipo ||
        cantidad === 0
    ) {

        return null;
    }


    const objeto =
        OBJETOS.find(
            item =>
                item.tipo === tipo
        );


    if (
        !objeto
    ) {

        return null;
    }


    const Uno =
        objeto.Uno;


    return (

        <div
            style={{
                width:
                    '100%',

                display:
                    'flex',

                flexWrap:
                    'wrap',

                gap:
                    12,

                justifyContent:
                    'center',

                alignItems:
                    'flex-end'
            }}
        >

            {
                range(
                    cantidad
                )
                    .map(
                        entero => (

                            <Uno
                                key={
                                    entero
                                }
                                id={
                                    `m154-${tipo}-${entero}`
                                }
                                n={
                                    n
                                }
                                q={
                                    q.slice(
                                        entero *
                                        n,

                                        entero *
                                        n +
                                        n
                                    )
                                }
                                onTocar={
                                    parte =>
                                        onTocar(
                                            entero,
                                            parte
                                        )
                                }
                                activo={
                                    activo
                                }
                                size={
                                    objeto.tam(
                                        cantidad
                                    )
                                }
                                bebida="jugo"
                            />
                        )
                    )
            }

        </div>
    );
};


// ============================================================================
// BANDEJAS
// ============================================================================

const Bandejas = ({
    cantidad,
    partes,
    pintadas,
    onTocar,
    activo
}) => {

    if (
        cantidad === 0
    ) {

        return null;
    }


    const width =
        220;

    const height =
        70;


    return (

        <div
            style={{
                width:
                    '100%',

                display:
                    'flex',

                flexWrap:
                    'wrap',

                gap:
                    12,

                justifyContent:
                    'center'
            }}
        >

            {
                range(
                    cantidad
                )
                    .map(
                        bandeja => (

                            <svg
                                key={
                                    bandeja
                                }
                                viewBox={
                                    `0 0 ${width + 8} ${height + 8}`
                                }
                                style={{
                                    width:
                                        228,

                                    maxWidth:
                                        '100%',

                                    height:
                                        'auto',

                                    display:
                                        'block'
                                }}
                                role="img"
                                aria-label={
                                    `Bandeja ${bandeja + 1}`
                                }
                            >

                                {
                                    range(
                                        partes
                                    )
                                        .map(
                                            parte => (

                                                <rect
                                                    key={
                                                        parte
                                                    }
                                                    x={
                                                        4 +
                                                        (
                                                            parte *
                                                            width
                                                        ) /
                                                        partes
                                                    }
                                                    y={
                                                        4
                                                    }
                                                    width={
                                                        width /
                                                        partes
                                                    }
                                                    height={
                                                        height
                                                    }
                                                    fill={
                                                        pintadas[
                                                            bandeja *
                                                            partes +
                                                            parte
                                                        ]

                                                            ? PINTADO
                                                            : '#F4F1EC'
                                                    }
                                                    stroke="#333333"
                                                    strokeWidth={
                                                        2
                                                    }
                                                    style={
                                                        cursor(
                                                            activo
                                                        )
                                                    }
                                                    onClick={() => {

                                                        if (
                                                            activo
                                                        ) {

                                                            onTocar(
                                                                bandeja,
                                                                parte
                                                            );
                                                        }
                                                    }}
                                                />
                                            )
                                        )
                                }


                                <rect
                                    x={
                                        4
                                    }
                                    y={
                                        4
                                    }
                                    width={
                                        width
                                    }
                                    height={
                                        height
                                    }
                                    rx={
                                        3
                                    }
                                    fill="none"
                                    stroke="#333333"
                                    strokeWidth={
                                        3.5
                                    }
                                    pointerEvents="none"
                                />

                            </svg>
                        )
                    )
            }

        </div>
    );
};


// ============================================================================
// RECTA NUMÉRICA
// ============================================================================

const Recta = ({
    limite,
    usar,
    cantidadBandejas,
    partes,
    pintadas,
    marca,
    onTocarParte,
    onClicRecta,
    done,
    valor
}) => {

    const X0 = 70;

    const UNIT =
        Math.min(
            170,
            820 /
            limite
        );

    const Y = 170;

    const W =
        X0 *
        2 +
        UNIT *
        limite;

    const H =
        260;

    const TY =
        Y -
        66;

    const TH =
        46;


    const toX = (
        valorX
    ) => {

        return (
            X0 +
            valorX *
            UNIT
        );
    };


    const clic = (
        e
    ) => {

        if (
            done
        ) {

            return;
        }


        const svg =
            e.currentTarget
                .ownerSVGElement;


        if (
            !svg
        ) {

            return;
        }


        const pt =
            svg.createSVGPoint();


        pt.x =
            e.clientX;

        pt.y =
            e.clientY;


        const matrix =
            svg.getScreenCTM();


        if (
            !matrix
        ) {

            return;
        }


        const local =
            pt.matrixTransform(
                matrix.inverse()
            );


        onClicRecta(

            Math.max(
                0,
                Math.min(
                    limite,
                    (
                        local.x -
                        X0
                    ) /
                    UNIT
                )
            )
        );
    };


    return (

        <svg
            viewBox={
                `0 0 ${W} ${H}`
            }
            style={{
                width:
                    '100%',

                maxWidth:
                    W,

                height:
                    'auto',

                display:
                    'block',

                userSelect:
                    'none'
            }}
            role="img"
            aria-label="Recta numérica"
        >

            <line
                x1={
                    toX(
                        0
                    ) -
                    45
                }
                y1={
                    Y
                }
                x2={
                    toX(
                        limite
                    ) +
                    45
                }
                y2={
                    Y
                }
                stroke={
                    INK
                }
                strokeWidth={
                    3
                }
            />


            <polygon
                points={
                    `${toX(0) - 58},${Y} ${toX(0) - 43},${Y - 9} ${toX(0) - 43},${Y + 9}`
                }
                fill={
                    INK
                }
            />


            <polygon
                points={
                    `${toX(limite) + 58},${Y} ${toX(limite) + 43},${Y - 9} ${toX(limite) + 43},${Y + 9}`
                }
                fill={
                    INK
                }
            />


            {
                range(
                    limite +
                    1
                )
                    .map(
                        numero => (

                            <g
                                key={
                                    numero
                                }
                            >

                                <line
                                    x1={
                                        toX(
                                            numero
                                        )
                                    }
                                    y1={
                                        Y -
                                        12
                                    }
                                    x2={
                                        toX(
                                            numero
                                        )
                                    }
                                    y2={
                                        Y +
                                        12
                                    }
                                    stroke={
                                        INK
                                    }
                                    strokeWidth={
                                        3
                                    }
                                />


                                <text
                                    x={
                                        toX(
                                            numero
                                        )
                                    }
                                    y={
                                        Y +
                                        40
                                    }
                                    textAnchor="middle"
                                    fontSize="22"
                                    fontWeight="600"
                                    fill={
                                        INK
                                    }
                                >
                                    {
                                        numero
                                    }
                                </text>

                            </g>
                        )
                    )
            }


            <rect
                x={
                    toX(
                        0
                    ) -
                    20
                }
                y={
                    Y -
                    14
                }
                width={
                    UNIT *
                    limite +
                    40
                }
                height={
                    60
                }
                fill="transparent"
                style={
                    cursor(
                        !done
                    )
                }
                onClick={
                    done
                        ? undefined
                        : clic
                }
            />


            {
                usar &&

                range(
                    cantidadBandejas
                )
                    .map(
                        bandeja => (

                            <g
                                key={
                                    bandeja
                                }
                            >

                                {
                                    range(
                                        partes
                                    )
                                        .map(
                                            parte => (

                                                <rect
                                                    key={
                                                        parte
                                                    }
                                                    x={
                                                        toX(
                                                            bandeja
                                                        ) +
                                                        (
                                                            parte *
                                                            UNIT
                                                        ) /
                                                        partes
                                                    }
                                                    y={
                                                        TY
                                                    }
                                                    width={
                                                        UNIT /
                                                        partes
                                                    }
                                                    height={
                                                        TH
                                                    }
                                                    fill={
                                                        pintadas[
                                                            bandeja *
                                                            partes +
                                                            parte
                                                        ]

                                                            ? PINTADO
                                                            : '#F4F1EC'
                                                    }
                                                    stroke="#333333"
                                                    strokeWidth={
                                                        2
                                                    }
                                                    style={
                                                        cursor(
                                                            !done
                                                        )
                                                    }
                                                    onClick={() => {

                                                        if (
                                                            !done
                                                        ) {

                                                            onTocarParte(
                                                                bandeja,
                                                                parte
                                                            );
                                                        }
                                                    }}
                                                />
                                            )
                                        )
                                }


                                <rect
                                    x={
                                        toX(
                                            bandeja
                                        )
                                    }
                                    y={
                                        TY
                                    }
                                    width={
                                        UNIT
                                    }
                                    height={
                                        TH
                                    }
                                    fill="none"
                                    stroke="#333333"
                                    strokeWidth={
                                        3
                                    }
                                    rx={
                                        3
                                    }
                                    pointerEvents="none"
                                />

                            </g>
                        )
                    )
            }


            {
                marca !== null && (

                    <g
                        pointerEvents="none"
                    >

                        <circle
                            cx={
                                toX(
                                    marca
                                )
                            }
                            cy={
                                Y
                            }
                            r={
                                9
                            }
                            fill={
                                done
                                    ? OK
                                    : MARK
                            }
                            stroke="#FFFFFF"
                            strokeWidth={
                                2
                            }
                        />


                        {
                            done && (

                                <foreignObject
                                    x={
                                        toX(
                                            marca
                                        ) -
                                        60
                                    }
                                    y={
                                        Y +
                                        46
                                    }
                                    width={
                                        120
                                    }
                                    height={
                                        70
                                    }
                                >

                                    <div
                                        style={{
                                            display:
                                                'flex',

                                            justifyContent:
                                                'center'
                                        }}
                                    >

                                        <Numero
                                            {...valor}
                                            size={
                                                30
                                            }
                                        />

                                    </div>

                                </foreignObject>
                            )
                        }

                    </g>
                )
            }

        </svg>
    );
};


// ============================================================================
// ESTADO INICIAL
// ============================================================================

const estadoInicial = () => ({

    etapa:
        0,

    hecho:
        false,

    // ------------------------------------------------------------------------
    // OBJETOS
    // ------------------------------------------------------------------------

    tipo:
        null,

    W:
        0,

    n:
        1,

    q:
        [],

    // ------------------------------------------------------------------------
    // BANDEJAS
    // ------------------------------------------------------------------------

    B:
        0,

    p:
        1,

    pint:
        [],

    // ------------------------------------------------------------------------
    // RECTA
    // ------------------------------------------------------------------------

    usar:
        false,

    B3:
        0,

    p3:
        1,

    pint3:
        [],

    mark:
        null
});


// ============================================================================
// COMPONENTE
// ============================================================================

const M154 = () => {


    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const [config] =
        useConfigAuth();


    // =========================================================================
    // REDUX
    // =========================================================================

    const iniciar =
        useSelector(
            state =>
                state.ejercicio.iniciar
        );


    const finalizar =
        useSelector(
            state =>
                state.ejercicio.finalizar
        );


    const id_paciente =
        useSelector(
            state =>
                state.usuario.id_paciente
        );


    const sesion =
        useSelector(
            state =>
                state.ejercicio.sesion
        );


    // =========================================================================
    // EJERCICIOS
    // =========================================================================

    const [
        ejercicios,
        setEjercicios
    ] = useState([]);


    const [
        count,
        setCount
    ] = useState(0);


    const [
        st,
        setSt
    ] = useState(
        estadoInicial
    );


    // =========================================================================
    // FEEDBACK / ANIMACIÓN
    // =========================================================================

    const [
        feedback,
        setFeedback
    ] = useState(null);


    const [
        disable,
        setDisable
    ] = useState(false);


    const [
        isIncorrect,
        setIsIncorrect
    ] = useState(false);


    const [
        isCorrect,
        setIsCorrect
    ] = useState(false);


    // =========================================================================
    // ERRORES
    // =========================================================================

    const [
        contarErrores,
        setContarErrores
    ] = useState(0);


    const [
        erroresItemActual,
        setErroresItemActual
    ] = useState(0);


    const [
        erroresOrden,
        setErroresOrden
    ] = useState([]);


    // =========================================================================
    // NÚMEROS REALIZADOS
    // =========================================================================

    const [
        respuestasOrden,
        setRespuestasOrden
    ] = useState([]);


    // =========================================================================
    // NÚMERO ACTUAL
    // =========================================================================

    const numeroActual =
        ejercicios.length > 0

            ? ejercicios[
                count
            ]

            : null;


    const T =
        numeroActual

            ? numeroActual.e *
                numeroActual.den +
                numeroActual.num

            : 0;


    const D =
        numeroActual
            ? numeroActual.den
            : 1;


    const valor =
        T /
        D;


    const limiteRecta =
        Math.max(
            3,
            Math.min(
                5,
                Math.ceil(
                    valor
                ) +
                1
            )
        );


    // =========================================================================
    // SONIDOS
    // =========================================================================

    const GoodWork = () => {

        new Audio(
            '/sounds/sonido_bien.mp3'
        ).play();
    };


    const TryAgain = () => {

        new Audio(
            '/sounds/sonidoMal.mp3'
        ).play();
    };


    // =========================================================================
    // ACTUALIZACIÓN SEGURA
    // =========================================================================

    const actualizar = (
        callback
    ) => {

        setSt(
            anterior => {

                const cambios =
                    typeof callback === 'function'

                        ? callback(
                            anterior
                        )

                        : callback;


                return {
                    ...anterior,
                    ...cambios
                };
            }
        );


        setFeedback(
            null
        );
    };


    // =========================================================================
    // ERROR
    // =========================================================================

    const marcarError = (
        texto
    ) => {

        setContarErrores(
            errores =>
                errores +
                1
        );


        setErroresItemActual(
            errores =>
                errores +
                1
        );


        setFeedback({
            ok:
                false,

            text:
                texto
        });


        setDisable(
            true
        );


        setIsIncorrect(
            true
        );


        TryAgain();


        setTimeout(() => {

            setIsIncorrect(
                false
            );


            setDisable(
                false
            );

        }, 300);
    };


    // =========================================================================
    // ETAPA 1
    // OBJETOS
    // =========================================================================

    const elegirObjeto = (
        tipo
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {


                // =============================================================
                // CAMBIA DE TIPO DE OBJETO
                // =============================================================

                if (
                    anterior.tipo !== tipo
                ) {

                    return {

                        tipo,

                        W:
                            1,

                        q:
                            Array(
                                anterior.n
                            ).fill(
                                false
                            )
                    };
                }


                // =============================================================
                // MISMO OBJETO
                // AGREGA UN ENTERO
                // =============================================================

                if (
                    anterior.W >=
                    MAX_ENTEROS
                ) {

                    return {};
                }


                return {

                    W:
                        anterior.W +
                        1,

                    q: [
                        ...anterior.q,

                        ...Array(
                            anterior.n
                        ).fill(
                            false
                        )
                    ]
                };
            }
        );
    };


    // =========================================================================
    // SACAR UN ENTERO
    //
    // IMPORTANTE:
    // SI EL CHICO SE EQUIVOCA Y AGREGA ENTEROS DE MÁS,
    // LOS PUEDE SACAR SIEMPRE ANTES DE VALIDAR.
    // =========================================================================

    const sacarEntero = () => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.W <= 0
                ) {

                    return {};
                }


                const nuevaCantidad =
                    anterior.W -
                    1;


                return {

                    W:
                        nuevaCantidad,

                    q:
                        anterior.q.slice(
                            0,
                            nuevaCantidad *
                            anterior.n
                        )
                };
            }
        );
    };


    // =========================================================================
    // PARTIR OBJETOS
    // =========================================================================

    const partirObjetos = (
        partes
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => ({

                n:
                    partes,

                q:
                    Array(
                        anterior.W *
                        partes
                    ).fill(
                        false
                    )
            })
        );
    };


    // =========================================================================
    // TOCAR / SACAR PARTE
    // =========================================================================

    const tocarObjeto = (
        entero,
        parte
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                const n =
                    anterior.n;


                // =============================================================
                // BOTELLA
                // =============================================================

                if (
                    anterior.tipo ===
                    'botella'
                ) {

                    const tramo =
                        anterior.q.slice(
                            entero *
                            n,

                            entero *
                            n +
                            n
                        );


                    const nivel =
                        n -
                        tramo.filter(
                            Boolean
                        ).length;


                    const nuevo =
                        parte <
                        nivel

                            ? parte
                            : parte +
                            1;


                    const q = [
                        ...anterior.q
                    ];


                    range(
                        n
                    )
                        .forEach(
                            index => {

                                q[
                                    entero *
                                    n +
                                    index
                                ] =
                                    index >=
                                    nuevo;
                            }
                        );


                    return {
                        q
                    };
                }


                // =============================================================
                // RESTO DE LOS OBJETOS
                // =============================================================

                const posicion =
                    entero *
                    n +
                    parte;


                return {

                    q:
                        anterior.q.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index ===
                                posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    // =========================================================================
    // ETAPA 2
    // BANDEJAS
    // =========================================================================

    const ponerBandeja = () => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B >= 6
                ) {

                    return {};
                }


                return {

                    B:
                        anterior.B +
                        1,

                    pint: [
                        ...anterior.pint,

                        ...Array(
                            anterior.p
                        ).fill(
                            false
                        )
                    ]
                };
            }
        );
    };


    const sacarBandeja = () => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B <= 0
                ) {

                    return {};
                }


                const nuevaCantidad =
                    anterior.B -
                    1;


                return {

                    B:
                        nuevaCantidad,

                    pint:
                        anterior.pint.slice(
                            0,
                            nuevaCantidad *
                            anterior.p
                        )
                };
            }
        );
    };


    const partirBandejas = (
        partes
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => ({

                p:
                    partes,

                pint:
                    Array(
                        anterior.B *
                        partes
                    ).fill(
                        false
                    )
            })
        );
    };


    const pintar = (
        bandeja,
        parte
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                const posicion =
                    bandeja *
                    anterior.p +
                    parte;


                return {

                    pint:
                        anterior.pint.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index ===
                                posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    // =========================================================================
    // ETAPA 3
    // RECTA
    // =========================================================================

    const ponerBandejaRecta = () => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B3 >=
                    limiteRecta
                ) {

                    return {};
                }


                return {

                    usar:
                        true,

                    B3:
                        anterior.B3 +
                        1,

                    pint3: [
                        ...anterior.pint3,

                        ...Array(
                            anterior.p3
                        ).fill(
                            false
                        )
                    ]
                };
            }
        );
    };


    const sacarBandejaRecta = () => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                if (
                    anterior.B3 <= 0
                ) {

                    return {};
                }


                const nuevaCantidad =
                    anterior.B3 -
                    1;


                return {

                    B3:
                        nuevaCantidad,

                    usar:
                        nuevaCantidad >
                        0,

                    pint3:
                        anterior.pint3.slice(
                            0,
                            nuevaCantidad *
                            anterior.p3
                        )
                };
            }
        );
    };


    const partirBandejasRecta = (
        partes
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => ({

                p3:
                    partes,

                pint3:
                    Array(
                        anterior.B3 *
                        partes
                    ).fill(
                        false
                    )
            })
        );
    };


    const pintarRecta = (
        bandeja,
        parte
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                const posicion =
                    bandeja *
                    anterior.p3 +
                    parte;


                return {

                    pint3:
                        anterior.pint3.map(
                            (
                                valorActual,
                                index
                            ) =>

                                index ===
                                posicion

                                    ? !valorActual
                                    : valorActual
                        )
                };
            }
        );
    };


    const marcarRecta = (
        numero
    ) => {

        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        actualizar(
            anterior => {

                let marca =
                    Math.round(
                        numero *
                        100
                    ) /
                    100;


                // =============================================================
                // SI USA BANDEJAS, LA MARCA SE PEGA A LA DIVISIÓN CERCANA
                // =============================================================

                if (
                    anterior.usar &&
                    anterior.B3 > 0 &&
                    anterior.p3 > 1
                ) {

                    const paso =
                        Math.round(
                            numero *
                            anterior.p3
                        ) /
                        anterior.p3;


                    if (
                        Math.abs(
                            paso -
                            numero
                        ) <
                        0.07
                    ) {

                        marca =
                            paso;
                    }
                }


                return {
                    mark:
                        marca
                };
            }
        );
    };


    // =========================================================================
    // ETAPA CORRECTA
    //
    // NO HAY QUE VOLVER A TOCAR PLAY.
    //
    // CORRECTO:
    // - BLOQUEA
    // - ZOOM
    // - SONIDO
    // - 300 ms
    // - AVANZA SOLO
    // =========================================================================

    const etapaCorrecta = () => {

        const etapaActual =
            st.etapa;


        const textos = [

            '¡Muy bien! Lo representaste con objetos.',

            '¡Muy bien! Lo representaste con bandejas.',

            '¡Excelente! Lo ubicaste en la recta numérica.'

        ];


        setDisable(
            true
        );


        setIsCorrect(
            true
        );


        setSt(
            anterior => ({

                ...anterior,

                hecho:
                    true
            })
        );


        setFeedback({

            ok:
                true,

            text:
                textos[
                    etapaActual
                ]
        });


        GoodWork();


        setTimeout(() => {


            setIsCorrect(
                false
            );


            // =================================================================
            // PASAR AUTOMÁTICAMENTE A LA SIGUIENTE REPRESENTACIÓN
            // =================================================================

            if (
                etapaActual < 2
            ) {

                setSt(
                    anterior => ({

                        ...anterior,

                        etapa:
                            etapaActual +
                            1,

                        hecho:
                            false
                    })
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ LAS TRES REPRESENTACIONES DEL NÚMERO
            // =================================================================

            const nuevaLista = [

                ...respuestasOrden,

                textoNumero(
                    numeroActual
                )

            ];


            const nuevosErrores = [

                ...erroresOrden,

                erroresItemActual

            ];


            setRespuestasOrden(
                nuevaLista
            );


            setErroresOrden(
                nuevosErrores
            );


            // =================================================================
            // SIGUIENTE NÚMERO
            // =================================================================

            if (
                count <
                ejercicios.length -
                1
            ) {

                setCount(
                    anterior =>
                        anterior +
                        1
                );


                setSt(
                    estadoInicial()
                );


                setErroresItemActual(
                    0
                );


                setFeedback(
                    null
                );


                setDisable(
                    false
                );


                return;
            }


            // =================================================================
            // TERMINÓ M154
            // =================================================================

            setFeedback(
                null
            );


            setTimeout(() => {

                dispatch(
                    finalizarEjercicioAction()
                );

            }, 0);


        }, 300);
    };


    // =========================================================================
    // COMPROBAR
    // =========================================================================

    const comprobar = () => {

        if (
            disable ||
            st.hecho ||
            !numeroActual
        ) {

            return;
        }


        const necesarios =
            Math.ceil(
                valor
            );


        // =====================================================================
        // ETAPA 1
        // OBJETOS
        // =====================================================================

        if (
            st.etapa === 0
        ) {

            if (
                !st.tipo ||
                st.W === 0
            ) {

                marcarError(
                    'Primero elegí un objeto y ponelo.'
                );

                return;
            }


            const quedan =
                st.W *
                st.n -
                st.q.filter(
                    Boolean
                ).length;


            // =================================================================
            // CORRECTO
            // =================================================================

            if (
                quedan *
                D ===
                T *
                st.n
            ) {

                etapaCorrecta();

                return;
            }


            // =================================================================
            // LE FALTAN ENTEROS
            // =================================================================

            if (
                st.W <
                necesarios
            ) {

                marcarError(
                    'Necesitás más enteros. Mirá el número: ¿cuántos enteros necesitás representar?'
                );

                return;
            }


            // =================================================================
            // PARTICIÓN INCORRECTA
            // =================================================================

            if (
                (
                    T *
                    st.n
                ) %
                D !==
                0
            ) {

                marcarError(
                    'Mirá el número de abajo de la fracción: ¿en cuántas partes conviene partir cada entero?'
                );

                return;
            }


            // =================================================================
            // SOBRA
            // =================================================================

            if (
                quedan *
                D >
                T *
                st.n
            ) {

                marcarError(
                    'Te sobra. Sacá las partes que no van.'
                );

                return;
            }


            // =================================================================
            // FALTA
            // =================================================================

            marcarError(
                'Te falta. Sacaste partes de más.'
            );


            return;
        }


        // =====================================================================
        // ETAPA 2
        // BANDEJAS
        // =====================================================================

        if (
            st.etapa === 1
        ) {

            if (
                st.B === 0
            ) {

                marcarError(
                    'Primero poné las bandejas que necesites.'
                );

                return;
            }


            const pintadas =
                st.pint.filter(
                    Boolean
                ).length;


            // =================================================================
            // CORRECTO
            // =================================================================

            if (
                pintadas *
                D ===
                T *
                st.p
            ) {

                etapaCorrecta();

                return;
            }


            // =================================================================
            // FALTAN BANDEJAS
            // =================================================================

            if (
                st.B <
                necesarios
            ) {

                marcarError(
                    'Necesitás más bandejas. Cada bandeja representa un entero.'
                );

                return;
            }


            // =================================================================
            // PARTICIÓN
            // =================================================================

            if (
                (
                    T *
                    st.p
                ) %
                D !==
                0
            ) {

                marcarError(
                    'Mirá el denominador: ¿en cuántas partes conviene partir cada bandeja?'
                );

                return;
            }


            // =================================================================
            // PINTÓ DE MÁS
            // =================================================================

            if (
                pintadas *
                D >
                T *
                st.p
            ) {

                marcarError(
                    'Pintaste de más.'
                );

                return;
            }


            // =================================================================
            // FALTA PINTAR
            // =================================================================

            marcarError(
                'Te falta pintar.'
            );


            return;
        }


        // =====================================================================
        // ETAPA 3
        // RECTA
        // =====================================================================

        if (
            st.mark === null
        ) {

            marcarError(
                'Hacé clic en la recta donde va el número.'
            );

            return;
        }


        // =====================================================================
        // CORRECTO
        // =====================================================================

        if (
            Math.abs(
                st.mark -
                valor
            ) <
            0.05
        ) {

            etapaCorrecta();

            return;
        }


        // =====================================================================
        // ERROR
        // =====================================================================

        marcarError(

            (
                st.mark >
                valor

                    ? 'Te pasaste.'
                    : 'Te quedaste corto.'
            ) +

            (
                st.usar

                    ? ''
                    : ' Podés usar las bandejas para ayudarte.'
            )
        );
    };


    // =========================================================================
    // BOTÓN PLAY
    //
    // SOLO COMPRUEBA.
    // NUNCA SE USA PARA AVANZAR.
    // =========================================================================

    const verificar = (
        e
    ) => {

        e.preventDefault();


        if (
            disable ||
            st.hecho
        ) {

            return;
        }


        comprobar();
    };


    // =========================================================================
    // INICIALIZAR
    // =========================================================================

    useEffect(() => {

        const seleccion =
            mezclar(
                NUMEROS
            )
                .slice(
                    0,
                    CANTIDAD_EJERCICIOS
                );


        setEjercicios(
            seleccion
        );


        setCount(
            0
        );


        setSt(
            estadoInicial()
        );


        dispatch(
            setearEjercicioAction(
                'M154'
            )
        );


        dispatch(
            setearUrlAnteriorAction(
                'matematica/fracciones/'
            )
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // =========================================================================
    // GUARDAR
    // =========================================================================

    useEffect(() => {

        if (
            !finalizar
        ) {

            return;
        }


        const informacion = {

            config,

            payload: {

                ejercicio:
                    'M154',

                errores:
                    contarErrores,

                lista_usada:
                    respuestasOrden,

                erroresOrden,

                id_paciente,

                sesion
            }
        };


        dispatch(
            almacenarAction(
                informacion
            )
        );


        navigate(
            '/escritorio/metodos/finalizar-ejercicio'
        );


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);


    // =========================================================================
    // PANTALLA DE INSTRUCCIONES
    // =========================================================================

    if (
        !iniciar
    ) {

        return (

            <Fragment>

                <HeaderEjercicios
                    estrellas={
                        true
                    }
                    carrito={
                        true
                    }
                    minMay={
                        false
                    }
                />


                <Instrucciones
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />

            </Fragment>
        );
    }


    if (
        !numeroActual
    ) {

        return null;
    }


    // =========================================================================
    // RENDER
    // =========================================================================

    return (

        <PantallaM154>


            <HeaderEjercicios
                estrellas={
                    true
                }
                carrito={
                    true
                }
                minMay={
                    false
                }
            />


            <ContenidoM154>


                <ContainerFlex
                    height="100%"
                    width="100%"
                    display="flex"
                    direction="column"
                    justify="center"
                    align="center"
                    isCorrect={
                        isCorrect
                    }
                    isIncorrect={
                        isIncorrect
                    }
                    $mantengoMay={
                        true
                    }
                >


                    <ZonaTrabajoM154>


                        {/* ================================================= */}
                        {/* NÚMERO OBJETIVO                                   */}
                        {/* ================================================= */}

                        <NumeroObjetivoM154>

                            <p>
                                Representá:
                            </p>


                            <Numero
                                {...numeroActual}
                                size={
                                    105
                                }
                            />

                        </NumeroObjetivoM154>


                        {/* ================================================= */}
                        {/* ACTIVIDAD                                         */}
                        {/* ================================================= */}

                        <ActividadM154>


                            {/* ============================================= */}
                            {/* ETAPA 1                                       */}
                            {/* OBJETOS                                       */}
                            {/* ============================================= */}

                            {
                                st.etapa === 0 && (

                                    <>

                                        <p
                                            className="consigna-m154"
                                        >
                                            Elegí un objeto. Cada vez que lo tocás, agregás un entero.
                                        </p>


                                        <div
                                            className="botones-m154"
                                        >

                                            {
                                                OBJETOS.map(
                                                    objeto => (

                                                        <button
                                                            key={
                                                                objeto.tipo
                                                            }
                                                            type="button"
                                                            style={{
                                                                ...(
                                                                    st.tipo === objeto.tipo

                                                                        ? botonSeleccionado
                                                                        : boton
                                                                ),

                                                                opacity:
                                                                    disable ||
                                                                    st.hecho

                                                                        ? 0.5
                                                                        : 1,

                                                                cursor:
                                                                    disable ||
                                                                    st.hecho

                                                                        ? 'default'
                                                                        : 'pointer'
                                                            }}
                                                            disabled={
                                                                disable ||
                                                                st.hecho
                                                            }
                                                            onClick={() =>
                                                                elegirObjeto(
                                                                    objeto.tipo
                                                                )
                                                            }
                                                        >
                                                            {
                                                                objeto.nombre
                                                            }
                                                        </button>
                                                    )
                                                )
                                            }


                                            {
                                                st.W > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                disable ||
                                                                st.hecho

                                                                    ? 0.5
                                                                    : 1,

                                                            cursor:
                                                                disable ||
                                                                st.hecho

                                                                    ? 'default'
                                                                    : 'pointer'
                                                        }}
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        onClick={
                                                            sacarEntero
                                                        }
                                                    >
                                                        Sacar un entero
                                                    </button>
                                                )
                                            }

                                        </div>


                                        <EscenaM154
                                            $tipo={
                                                st.tipo
                                            }
                                        >

                                            <Objetos
                                                tipo={
                                                    st.tipo
                                                }
                                                cantidad={
                                                    st.W
                                                }
                                                n={
                                                    st.n
                                                }
                                                q={
                                                    st.q
                                                }
                                                onTocar={
                                                    tocarObjeto
                                                }
                                                activo={
                                                    !disable &&
                                                    !st.hecho
                                                }
                                            />

                                        </EscenaM154>


                                        {
                                            st.W > 0 && (

                                                <>

                                                    <Partir
                                                        valor={
                                                            st.n
                                                        }
                                                        onCambio={
                                                            partirObjetos
                                                        }
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                    />


                                                    <p
                                                        className="ayuda-m154"
                                                    >
                                                        Tocá las partes que sobran para sacarlas.
                                                    </p>

                                                </>
                                            )
                                        }

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 2                                       */}
                            {/* BANDEJAS                                      */}
                            {/* ============================================= */}

                            {
                                st.etapa === 1 && (

                                    <>

                                        <p
                                            className="consigna-m154"
                                        >
                                            Representá el mismo número con bandejas.
                                        </p>


                                        <div
                                            className="botones-m154"
                                        >

                                            <button
                                                type="button"
                                                style={{
                                                    ...boton,

                                                    opacity:
                                                        disable ||
                                                        st.hecho

                                                            ? 0.5
                                                            : 1,

                                                    cursor:
                                                        disable ||
                                                        st.hecho

                                                            ? 'default'
                                                            : 'pointer'
                                                }}
                                                disabled={
                                                    disable ||
                                                    st.hecho
                                                }
                                                onClick={
                                                    ponerBandeja
                                                }
                                            >
                                                Poner bandeja
                                            </button>


                                            {
                                                st.B > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                disable ||
                                                                st.hecho

                                                                    ? 0.5
                                                                    : 1,

                                                            cursor:
                                                                disable ||
                                                                st.hecho

                                                                    ? 'default'
                                                                    : 'pointer'
                                                        }}
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        onClick={
                                                            sacarBandeja
                                                        }
                                                    >
                                                        Sacar bandeja
                                                    </button>
                                                )
                                            }

                                        </div>


                                        <EscenaM154>

                                            <Bandejas
                                                cantidad={
                                                    st.B
                                                }
                                                partes={
                                                    st.p
                                                }
                                                pintadas={
                                                    st.pint
                                                }
                                                onTocar={
                                                    pintar
                                                }
                                                activo={
                                                    !disable &&
                                                    !st.hecho
                                                }
                                            />

                                        </EscenaM154>


                                        {
                                            st.B > 0 && (

                                                <>

                                                    <Partir
                                                        valor={
                                                            st.p
                                                        }
                                                        onCambio={
                                                            partirBandejas
                                                        }
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        texto="Partir cada bandeja en:"
                                                    />


                                                    <p
                                                        className="ayuda-m154"
                                                    >
                                                        Pintá la cantidad que representa el número.
                                                    </p>

                                                </>
                                            )
                                        }

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* ETAPA 3                                       */}
                            {/* RECTA                                         */}
                            {/* ============================================= */}

                            {
                                st.etapa === 2 && (

                                    <>

                                        <p
                                            className="consigna-m154"
                                        >
                                            Ahora ubicá el mismo número en la recta numérica.
                                        </p>


                                        <EscenaM154
                                            $recta={
                                                true
                                            }
                                        >

                                            <Recta
                                                limite={
                                                    limiteRecta
                                                }
                                                usar={
                                                    st.usar
                                                }
                                                cantidadBandejas={
                                                    st.B3
                                                }
                                                partes={
                                                    st.p3
                                                }
                                                pintadas={
                                                    st.pint3
                                                }
                                                marca={
                                                    st.mark
                                                }
                                                onTocarParte={
                                                    pintarRecta
                                                }
                                                onClicRecta={
                                                    marcarRecta
                                                }
                                                done={
                                                    disable ||
                                                    st.hecho
                                                }
                                                valor={
                                                    numeroActual
                                                }
                                            />

                                        </EscenaM154>


                                        <div
                                            className="botones-m154"
                                        >

                                            <button
                                                type="button"
                                                style={{
                                                    ...boton,

                                                    opacity:
                                                        disable ||
                                                        st.hecho

                                                            ? 0.5
                                                            : 1,

                                                    cursor:
                                                        disable ||
                                                        st.hecho

                                                            ? 'default'
                                                            : 'pointer'
                                                }}
                                                disabled={
                                                    disable ||
                                                    st.hecho
                                                }
                                                onClick={
                                                    ponerBandejaRecta
                                                }
                                            >
                                                {
                                                    st.B3 === 0

                                                        ? 'Usar bandejas'
                                                        : 'Poner bandeja'
                                                }
                                            </button>


                                            {
                                                st.B3 > 0 && (

                                                    <button
                                                        type="button"
                                                        style={{
                                                            ...boton,

                                                            borderColor:
                                                                MARK,

                                                            color:
                                                                MARK,

                                                            opacity:
                                                                disable ||
                                                                st.hecho

                                                                    ? 0.5
                                                                    : 1,

                                                            cursor:
                                                                disable ||
                                                                st.hecho

                                                                    ? 'default'
                                                                    : 'pointer'
                                                        }}
                                                        disabled={
                                                            disable ||
                                                            st.hecho
                                                        }
                                                        onClick={
                                                            sacarBandejaRecta
                                                        }
                                                    >
                                                        Sacar bandeja
                                                    </button>
                                                )
                                            }

                                        </div>


                                        {
                                            st.B3 > 0 && (

                                                <Partir
                                                    valor={
                                                        st.p3
                                                    }
                                                    onCambio={
                                                        partirBandejasRecta
                                                    }
                                                    disabled={
                                                        disable ||
                                                        st.hecho
                                                    }
                                                    texto="Partir cada bandeja en:"
                                                />
                                            )
                                        }

                                    </>
                                )
                            }


                            {/* ============================================= */}
                            {/* FEEDBACK                                      */}
                            {/* ============================================= */}

                            <p
                                className={
                                    feedback

                                        ? feedback.ok

                                            ? 'feedback-m154 ok'
                                            : 'feedback-m154 error'

                                        : 'feedback-m154'
                                }
                            >
                                {
                                    feedback

                                        ? feedback.text
                                        : '.'
                                }
                            </p>


                        </ActividadM154>


                    </ZonaTrabajoM154>


                </ContainerFlex>


            </ContenidoM154>


            {/* ============================================================= */}
            {/* BOTTOM                                                        */}
            {/* ============================================================= */}

            <BottomM154>


                <BotoneraBottom
                    miniInstrucciones={
                        miniInstrucciones
                    }
                />


                <AvanzarBtn
                    disabled={
                        disable ||
                        st.hecho
                    }
                    onClick={
                        verificar
                    }
                >

                    <AvanzarImg
                        src="/img/play.png"
                    />

                </AvanzarBtn>


            </BottomM154>


        </PantallaM154>
    );
};


export default M154;